<div id="gateStateContainer" [class.compact]="compact()">
  <span class="title energyToolWidgetTitle"> {{ "energy_tool.gate_position.title" | translate }}</span>
  @if (timeout()) {
    <div class="timeoutContainer">
      <app-timeout />
    </div>
  } @else if (loading()) {
    <p-progressSpinner
      [ariaLabel]="'energy_tool.gate_position.title' | translate"
      class="pSpinner customProgressSpinner"
    />
  } @else {
    <div class="textContainer">
      <span class="stateText">
        @switch (gateStatus()?.value ?? gateStates.UNKNOWN) {
          @case (gateStates.CLOSE) {
            {{ "gate_position_widget.closed" | translate }}
          }
          @case (gateStates.OPEN) {
            {{ "gate_position_widget.open" | translate }}
          }
          @case (gateStates.PARTIAL) {
            {{ "gate_position_widget.partially_open" | translate }}
          }
          @case (gateStates.OPENING) {
            {{ "gate_position_widget.opening" | translate }}
          }
          @case (gateStates.CLOSING) {
            {{ "gate_position_widget.closing" | translate }}
          }
          @default {
            {{ "gate_position_widget.unknown" | translate }}
          }
        }
      </span>
      @if (animation()?.mode === animationModes.REPLAY) {
        <span class="animationHint">{{ "gate_position_widget.delayed_animation" | translate }}</span>
      }
      @if (animation()?.mode === animationModes.LIVE) {
        <span class="motionIndicator" aria-hidden="true">{{
          animation()?.direction === gateStates.OPENING ? "↑" : "↓"
        }}</span>
      }
      @if (!compact() && lastActionTimestamp()) {
        <span class="lastProcedureText"
          >{{ "energy_tool.last_operation" | translate }} {{ lastActionTimestamp() }}</span
        >
      }
    </div>
    <!-- Recreate the one-shot SVG for each new animation. -->
    @for (movement of [animation()]; track movement?.id) {
      @switch (iconStatus()) {
        @case (gateStates.CLOSE) {
          <ng-container *ngTemplateOutlet="closed"></ng-container>
        }
        @case (gateStates.OPEN) {
          <ng-container *ngTemplateOutlet="open"></ng-container>
        }
        @case (gateStates.PARTIAL) {
          <ng-container *ngTemplateOutlet="partiallyOpen"></ng-container>
        }
        @case (gateStates.OPENING) {
          <ng-container *ngTemplateOutlet="opening"></ng-container>
        }
        @case (gateStates.CLOSING) {
          <ng-container *ngTemplateOutlet="closing"></ng-container>
        }
        @default {
          <ng-container *ngTemplateOutlet="unknown"></ng-container>
        }
      }
    }
  }
</div>

<ng-template #open>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-100"
    iconColor="critical"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>

<ng-template #unknown>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-0"
    iconColor="warning"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>

<ng-template #closed>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-closed"
    iconColor="primary"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>

<ng-template #partiallyOpen>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-50"
    iconColor="warning"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>

<ng-template #opening>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-opening-animation"
    iconColor="primary"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>

<ng-template #closing>
  <app-svg-icon
    class="stateIcon"
    style="text-align: right"
    iconName="gate-closing-animation"
    iconColor="critical"
    iconSize="xl"
  ></app-svg-icon>
</ng-template>
